<template>
	<span class="justify-center items-center gap-10">
			<button
				v-if="user && user.member_id"
				class="box radius-20 text-center timer"
				@click="toConfirmReset"
			> {{ timer }}</button>

			<button
				v-if="false && user && user.member_id"
				class="text-15 text-vw-16 font-weight-bold hide-m"
				@click="toConfirmReset"
			>연장하기</button>

		<PopupConfirm
			v-if="is_on_reset"
			@click="toReset"
			@cancel="toResetCancel"
		>
			<template
				v-slot:title
			>자동로그 아웃</template>
			<template
				v-slot:main-txt
			>
				안전한 서비스 이용을 위해 잠시후 자동 로그아웃됩니다 <br/>
				로그인 시간을 연장하고 계속 이용하시겠습니까?
			</template>
		</PopupConfirm>
	</span>
</template>

<script>
	import PopupConfirm from "../view/Layout/PopupConfirm";
	export default {
		name: 'Timer'
		, components: {PopupConfirm}
		, props: ['user', 'shop_info']
		, data: function(){
			return {
				item_second: 7
				, item_minimum: 5
				, is_on_reset: false
				, is_reset_confirm: false
				, item_interval: ''
			}
		}
		, computed: {
			timer: function(){
				let t = ''

				t = this.$date.getTimer(this.item_second)

				return t
			}
		}
		, methods: {

			toResetCancel: function(){
				this.is_reset_confirm = true
				this.is_on_reset = false
			}
			, setTimer: function(){
				// console.log('setTimer', this.item_second, this.item_minimum)
				clearInterval(this.item_interval)
				if(this.user && this.user.member_id){
					this.item_interval = setInterval( () => {

						let t = sessionStorage.getItem('is_do')
						// console.log('is_do', t)
						if(t){
							this.item_second = this.shop_info?.session_limit
							this.item_minimum = this.shop_info?.session_noti
							sessionStorage.removeItem('is_do')
							// console.log('remove is_do')
						}

						// console.log('setTimer do ', this.item_second)
						if(this.item_second <= this.item_minimum){
							if(!this.is_on_reset && !this.is_reset_confirm){
								this.is_on_reset = true
							}
						}
						if(this.item_second <= 0){
							this.$bus.$emit('logout')
						}

						this.item_second--
					}, 1000)
				}else{
					// console.log('setTimer is gone')
					this.is_on_reset = false
					this.is_reset_confirm = false
				}
			}
			, toReset: async function(){
				try {
					this.$bus.$emit('on', true)
					const result = await this.$request.init({
						method: 'post'
						, url: '/auth/postReset'
					})
					if (result.success) {
						this.item_second = result.data.session_limit
						this.item_minimum = result.data.session_noti

						this.is_on_reset = false
						this.is_reset_confirm = false
					} else {
						throw result.message
					}
				} catch (e) {
					console.log(e.message)
					this.$bus.$emit('notify', {type: 'error', message: e})
				} finally {
					this.$bus.$emit('on', false)
				}
			}
			, toLogout: function(){
				if(confirm("로그아웃 하시겠습니까?")){
					this.$bus.$emit('logout')
				}
			}
			, toConfirmReset: function(){

				if(confirm('로그인 유지 시간을 연장하시겠습니까?')) {
					this.toReset()
				}
			}
		}
		, created() {
			this.item_second = this.shop_info?.session_limit
			this.item_minimum = this.shop_info?.session_noti
			this.setTimer()
		}

		,watch: {
			$route(){
				this.item_second = this.shop_info?.session_limit
				this.item_minimum = this.shop_info?.session_noti
			}
		}
	}
</script>